import React, { FC, useContext } from "react";

import { Context } from "../../../store/student";

import Banner from "./Banner";
import styles from "./Notice.module.scss";

type Props = {
  createCareerSheets: () => void;
};

const Notice: FC<Props> = ({ createCareerSheets }) => {
  const { contextState } = useContext(Context);

  const feedbackQuestions = contextState.career_feedback_questions;
  const latestFeedbackSheet = contextState.career_latest_feedback_sheet;

  const isCareerMapGenerated =
    latestFeedbackSheet !== null && latestFeedbackSheet.read_at === null;

  const unansweredQuestionIndex = feedbackQuestions.findIndex(
    question => question.realization === null,
  );

  const currentQuestion =
    unansweredQuestionIndex !== -1
      ? feedbackQuestions[unansweredQuestionIndex]
      : null;

  const isCompletedQuestions = feedbackQuestions.every(
    question => question.realization !== null,
  );

  const isQuestionActive =
    feedbackQuestions.length !== 0 && !isCompletedQuestions;

  const isSheetActive = feedbackQuestions.length !== 0 && isCompletedQuestions;

  const isGeneratingQuestions =
    latestFeedbackSheet?.read_at && feedbackQuestions.length === 0;

  const isNoticeActive =
    isCareerMapGenerated ||
    isQuestionActive ||
    isSheetActive ||
    isGeneratingQuestions;

  return (
    <>
      {isNoticeActive && (
        <div className={styles.wrapper}>
          {isCareerMapGenerated && <Banner type={"map"} />}
          {isGeneratingQuestions && (
            <Banner
              type={"questionGenerating"}
              createCareerSheets={createCareerSheets}
            />
          )}
          {isQuestionActive && (
            <Banner
              type={"question"}
              chartCount={unansweredQuestionIndex}
              chartLength={feedbackQuestions.length}
              questionTitle={currentQuestion?.title}
            />
          )}
          {isSheetActive && (
            <Banner type={"sheet"} createCareerSheets={createCareerSheets} />
          )}
        </div>
      )}
    </>
  );
};

export default Notice;
